import styles from './styles';

export default [
  {
    type: 'locked',
    id: 'bc_email',
    name: 'bc_email',
    value: 'notification@xpertdox.com',
    label: 'Email address this message will be sent from',
    styles: {borderRadius: '2px'},
  },
  {
    type: 'text',
    id: 'bc_subject',
    name: 'bc_subject',
    placeholder: 'Subject',
    label: 'Subject of this email broadcast',
    styles: styles.textInput,
  },
  {
    type: 'textarea',
    id: 'bc_message',
    name: 'bc_message',
    value: 'Dear [[user_name]], \n\n',
    placeholder: 'Message',
    label: 'Message of this email broadcast',
    styles: styles.textInput,
  },
];
